"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _is_after = _interopRequireDefault(require("date-fns/is_after"));
var _groupBy2 = _interopRequireDefault(require("lodash/groupBy"));
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _flightProduct = _interopRequireDefault(require("@tajawal/web-flights-sdk/lib/factories/flight-product.factory"));
var _constants2 = require("@tajawal/web-flights-sdk/lib/constants");
var _downloadOrderPdf = require("./download-order-pdf.store");
var _order = require("./order.store");
var _constants3 = require("../constants");
var _bookings = require("../utils/bookings.utils");
var _sale = require("./sale.store");
var _class; // stores
// @TODO when we update sdk on desktop & mweb update this to myaccount skd order store
// utils
// constants
/** *
 *  ManageOrderFlightBookingPageStore
 */
let ManageOrderFlightBookingPageStore = (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env
   */
  function ManageOrderFlightBookingPageStore(initialState = {}, $env) {
    (0, _classCallCheck2.default)(this, ManageOrderFlightBookingPageStore);
    this.$env = $env;
    this.updateInitialState(initialState);
    this.order = new _order.OrderStore(initialState.order, $env, _flightProduct.default);
    this.orderPdf = new _downloadOrderPdf.DownloadOrderPdfStore(initialState.orderPdf, $env);
    this.sale = new _sale.MyAccountSaleStore(initialState.sale, $env, _flightProduct.default, _constants3.PRODUCT_TYPES.FLIGHT);
  }

  /**
   * update initial state
   * @param {Object} initialState
   */
  (0, _createClass2.default)(ManageOrderFlightBookingPageStore, [{
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }

    /**
     * language
     * @return {string}
     */
  }, {
    key: "language",
    get: function () {
      return this.$env.config.language;
    }

    /**
     * Flight Product
     * @return {Object}
     */
  }, {
    key: "flightProduct",
    get: function () {
      return this.sale.product;
    }

    /**
     * Flight Itinerary
     * @return {Object}
     */
  }, {
    key: "itinerary",
    get: function () {
      return this.flightProduct.itinerary;
    }

    /**
     * Flight Resource Codes
     * @return {Array}
     */
  }, {
    key: "resourceCodes",
    get: function () {
      return (0, _get2.default)(this.flightProduct, 'resourceCodes', []);
    }

    /**
     * is Failed
     * @return {boolean}
     */
  }, {
    key: "isFailed",
    get: function () {
      console.log(_constants3.FLIGHT_BOOKING_STATUS.FAILURE, 'FLIGHT_BOOKING_STATUS.FAILURE');
      return _constants3.FLIGHT_BOOKING_STATUS.FAILURE === this.sale.status;
    }
  }, {
    key: "bookingTagStatus",
    get: function () {
      return (0, _bookings.getBookingTagStatus)(this.sale.displayStatus);
    }

    /**
     * is past trip
     * @return {boolean}
     */
  }, {
    key: "isPastTrip",
    get: function () {
      return (0, _is_after.default)(new Date(), (0, _get2.default)(this.flightProduct, 'lastDepartureDate'));
    }

    /**
     * is Trip Completed
     * @return {boolean}
     */
  }, {
    key: "isTripCompleted",
    get: function () {
      return this.sale.displayStatus !== 221 && this.sale.displayStatus !== 400 && !this.isFailed && this.isPastTrip;
    }

    /**
     * has Airline Reference
     * @return {boolean}
     */
  }, {
    key: "hasAirlineReference",
    get: function () {
      return this.sale.displayStatus !== 201 && !this.isFailed && !!this.flightProduct.airlineReference;
    }

    /**
     * Fare Rules Payload
     * @return {Object}
     */
  }, {
    key: "fareRulesPayload",
    get: function () {
      var _this$flightProduct, _this$flightProduct$i;
      return {
        cartId: this.sale.modifiedCartId,
        productId: this.flightProduct.id,
        isV3: this.flightProduct.isV3Pricing,
        fareUuid: this.flightProduct.fareUuid,
        vendor: this.flightProduct.vendor,
        airline: (_this$flightProduct = this.flightProduct) === null || _this$flightProduct === void 0 ? void 0 : (_this$flightProduct$i = _this$flightProduct.itinerary) === null || _this$flightProduct$i === void 0 ? void 0 : _this$flightProduct$i.validatingCarrier
      };
    }
  }, {
    key: "travellersType",
    get: function () {
      var _this$flightProduct2, _this$flightProduct3, _this$flightProduct3$;
      const groupTraveelers = (0, _groupBy2.default)((_this$flightProduct2 = this.flightProduct) === null || _this$flightProduct2 === void 0 ? void 0 : _this$flightProduct2.travellers, 'type');
      if ((_this$flightProduct3 = this.flightProduct) !== null && _this$flightProduct3 !== void 0 && (_this$flightProduct3$ = _this$flightProduct3.travellers) !== null && _this$flightProduct3$ !== void 0 && _this$flightProduct3$.length) {
        var _groupTraveelers$TRAV, _groupTraveelers$TRAV2, _groupTraveelers$TRAV3;
        return {
          numberOfAdult: ((_groupTraveelers$TRAV = groupTraveelers[_constants2.TRAVELLERS_TYPES_CODES_MAP.ADT]) === null || _groupTraveelers$TRAV === void 0 ? void 0 : _groupTraveelers$TRAV.length) || 0,
          numberOfChilden: ((_groupTraveelers$TRAV2 = groupTraveelers[_constants2.TRAVELLERS_TYPES_CODES_MAP.CHD]) === null || _groupTraveelers$TRAV2 === void 0 ? void 0 : _groupTraveelers$TRAV2.length) || 0,
          numberOfInfant: ((_groupTraveelers$TRAV3 = groupTraveelers[_constants2.TRAVELLERS_TYPES_CODES_MAP.INF]) === null || _groupTraveelers$TRAV3 === void 0 ? void 0 : _groupTraveelers$TRAV3.length) || 0
        };
      }
      return {
        numberOfAdult: 0,
        numberOfChilden: 0,
        numberOfInfant: 0
      };
    }
  }]);
  return ManageOrderFlightBookingPageStore;
}(), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "language", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "language"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "flightProduct", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "flightProduct"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "itinerary", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "itinerary"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resourceCodes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "resourceCodes"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFailed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFailed"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "bookingTagStatus", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "bookingTagStatus"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isPastTrip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPastTrip"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isTripCompleted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isTripCompleted"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasAirlineReference", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasAirlineReference"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "fareRulesPayload", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "fareRulesPayload"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "travellersType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "travellersType"), _class.prototype)), _class);
exports.default = ManageOrderFlightBookingPageStore;